/*jslint white: true, nomen: true */
/*global angular */
(function() {
  'use strict';

  angular.module('app.forms')
    .directive('formComponentPhoneSecondary', [function() {
      return {
        restrict: 'E',
        templateUrl: 'form-component-phone-secondary',
        replace: true,
        scope: {
          formObj: "=",
          formScope: "="
        },
        bindToController: true,
        controllerAs: 'vm',
        link: function() {},
        controller: [function() {}]
      };

    }]);
}());